(() => {

  const FREE_SHIPPING_THRESHOLD = 1500000;
  // Shopify内部では ¥15,000 = 1500000


  let updateTimer = null;
  let isUpdating = false;


  function getShopRoot() {
    return window.Shopify?.routes?.root || '/';
  }


  function formatMoney(value) {

    const currency =
      window.Shopify?.currency?.active || 'JPY';

    const amount =
      Number(value) / 100;


    return new Intl.NumberFormat(
      'ja-JP',
      {
        style: 'currency',
        currency: currency,
        maximumFractionDigits:
          currency === 'JPY' ? 0 : 2
      }
    ).format(amount);

  }


  async function getCart() {

    try {

      const response =
        await fetch(
          `${getShopRoot()}cart.js`,
          {
            method: 'GET',

            credentials:
              'same-origin',

            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (!response.ok) {
        throw new Error('Cart fetch failed');
      }


      return await response.json();


    } catch (error) {

      return null;

    }

  }


  function getCartDrawer() {

    return (
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer')
    );

  }


  function createProgressBar() {

    const wrapper =
      document.createElement('div');


    wrapper.className =
      'eg-free-shipping';


    wrapper.setAttribute(
      'data-eg-free-shipping',
      ''
    );


    wrapper.innerHTML = `

      <div class="eg-free-shipping__top">

        <div
          class="eg-free-shipping__message"
          data-eg-shipping-message
        >
          15,000円以上で送料無料
        </div>

      </div>


      <div
        class="eg-free-shipping__track"
        aria-hidden="true"
      >

        <div
          class="eg-free-shipping__progress"
          data-eg-shipping-progress
          style="width: 0%;"
        >
        </div>

      </div>


      <div
        class="eg-free-shipping__amount"
        data-eg-shipping-amount
      >
      </div>

    `;


    return wrapper;

  }


  function insertProgressBar() {

    const drawer =
      getCartDrawer();


    if (!drawer) return null;


    let existing =
      drawer.querySelector(
        '[data-eg-free-shipping]'
      );


    if (existing) {
      return existing;
    }


    const progressBar =
      createProgressBar();


    const footer =
      drawer.querySelector(
        '.cart-drawer__footer, .drawer__footer'
      );


    if (footer) {

      footer.insertAdjacentElement(
        'beforebegin',
        progressBar
      );


      return progressBar;

    }


    const drawerInner =
      drawer.querySelector(
        '.drawer__inner'
      );


    if (drawerInner) {

      drawerInner.appendChild(
        progressBar
      );


      return progressBar;

    }


    drawer.appendChild(
      progressBar
    );


    return progressBar;

  }


  function renderProgress(
    wrapper,
    cart
  ) {

    if (!wrapper || !cart) return;


    const message =
      wrapper.querySelector(
        '[data-eg-shipping-message]'
      );


    const progress =
      wrapper.querySelector(
        '[data-eg-shipping-progress]'
      );


    const amountText =
      wrapper.querySelector(
        '[data-eg-shipping-amount]'
      );


    const total =
      Number(cart.total_price || 0);


    const remaining =
      Math.max(
        0,
        FREE_SHIPPING_THRESHOLD - total
      );


    const percentage =
      Math.min(
        100,
        Math.max(
          0,
          (
            total /
            FREE_SHIPPING_THRESHOLD
          ) * 100
        )
      );


    progress.style.width =
      `${percentage}%`;


    if (
      cart.item_count === 0
    ) {

      message.innerHTML =
        `15,000円以上で<strong>国内送料無料</strong>`;

      amountText.textContent = '';

      wrapper.classList.remove(
        'is-complete'
      );

      return;

    }


    if (
      total >=
      FREE_SHIPPING_THRESHOLD
    ) {

      message.innerHTML =
        `<strong>送料無料になりました ✓</strong>`;

      amountText.textContent =
        'お買い物ありがとうございます';

      wrapper.classList.add(
        'is-complete'
      );


    } else {

      message.innerHTML =
        `あと <strong>${formatMoney(
          remaining
        )}</strong> で送料無料`;

      amountText.textContent =
        `${formatMoney(total)} / ${formatMoney(
          FREE_SHIPPING_THRESHOLD
        )}`;

      wrapper.classList.remove(
        'is-complete'
      );

    }

  }


  async function updateFreeShipping() {

    if (isUpdating) return;


    isUpdating = true;


    const wrapper =
      insertProgressBar();


    if (!wrapper) {

      isUpdating = false;

      return;

    }


    const cart =
      await getCart();


    if (cart) {

      renderProgress(
        wrapper,
        cart
      );

    }


    isUpdating = false;

  }


  function scheduleUpdate() {

    clearTimeout(
      updateTimer
    );


    updateTimer =
      window.setTimeout(
        updateFreeShipping,
        180
      );

  }


  document.addEventListener(
    'DOMContentLoaded',
    scheduleUpdate
  );


  document.addEventListener(
    'shopify:section:load',
    scheduleUpdate
  );


  document.addEventListener(
    'cart:refresh',
    scheduleUpdate
  );


  document.addEventListener(
    'cart:updated',
    scheduleUpdate
  );


  document.addEventListener(
    'product:added',
    scheduleUpdate
  );


  document.addEventListener(
    'change',
    (event) => {

      if (
        event.target.closest(
          'cart-drawer, #CartDrawer'
        )
      ) {

        scheduleUpdate();

      }

    }
  );


  const observer =
    new MutationObserver(
      (mutations) => {

        const relevant =
          mutations.some(
            mutation => {

              return Array.from(
                mutation.addedNodes
              ).some(
                node => {

                  if (
                    node.nodeType !== 1
                  ) {
                    return false;
                  }


                  return (
                    node.matches?.(
                      'cart-drawer, #CartDrawer'
                    ) ||
                    node.querySelector?.(
                      'cart-drawer, #CartDrawer'
                    )
                  );

                }
              );

            }
          );


        if (relevant) {
          scheduleUpdate();
        }

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  window.EgyptGlassFreeShipping = {
    update: scheduleUpdate
  };

})();